var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header__phone"},[_vm._v("+7 (495) 6-020-020")])])])
}]

export { render, staticRenderFns }